import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { intlShape } from '../../../components/base/IntlProviderWrapper';
import './authorized.scss';
import { loadOrganizationList } from '../actions';
import { responseLogWithNotification } from '../../../utils/utils';
import { getProfileData } from '../reducer';
import Loader from '../../../components/base/Loader/Loader';
import { UserOrganizationItem } from './UserOrganizationItem';
import { Accordion } from '../../../components/base/Accordion/Accordion';

export function UserOrganizationsList(props) {
  const {
    formatMessage,
  } = intlShape;
  const {
    userId = '',
  } = props;

  const dispatch = useDispatch();
  const {
    organizationList = [], loadingOrganizationList,
  } = useSelector(getProfileData);

  useEffect(() => {
    dispatch(loadOrganizationList({
      filter: {
        userId,
      },
    })).catch(responseLogWithNotification);
  }, []);

  return (
    <div>
      <Loader loading={loadingOrganizationList} />
      <div className="f3">{formatMessage({ id: 'user.profile.menu.organization' })}</div>
      <div className="mb-4" />
      <div className="uspd-organization-list custom-scroll-theme">
        {
          Array.isArray(organizationList) && organizationList.length ? organizationList.map(((organization, key) => (
            <Accordion
              key={key}
              variant="secondary"
              title={organization?.full_name}
              content={(
                <UserOrganizationItem
                  key={key}
                  item={organization}
                />
                )}
            />
          ))) : 'Нет данных'
          }
      </div>
      <Loader loading={loadingOrganizationList} />
    </div>
  );
}
